var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 24,
    rx: 4,
    fill: "#91D0AB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_3003)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7473 5.83006C15.4177 5.23764 13.9322 5.09088 12.5124 5.41166C11.0926 5.73244 9.81456 6.50359 8.86884 7.61009C7.92312 8.71658 7.36041 10.0991 7.26463 11.5516C7.16886 13.004 7.54516 14.4485 8.3374 15.6696C9.12964 16.8907 10.2954 17.823 11.6608 18.3274C13.0262 18.8318 14.518 18.8814 15.9139 18.4687C17.3097 18.056 18.5348 17.2031 19.4063 16.0373C20.2778 14.8715 20.7492 13.4551 20.75 11.9996V11.31C20.75 10.8958 21.0858 10.56 21.5 10.56C21.9142 10.56 22.25 10.8958 22.25 11.31V12C22.249 13.779 21.6729 15.5105 20.6077 16.9354C19.5425 18.3603 18.0452 19.4027 16.3392 19.9071C14.6331 20.4116 12.8097 20.351 11.1409 19.7345C9.47214 19.1179 8.04734 17.9785 7.07904 16.486C6.11074 14.9935 5.65083 13.2281 5.76788 11.4529C5.88494 9.67769 6.5727 7.98789 7.72858 6.6355C8.88447 5.28312 10.4465 4.34061 12.1819 3.94854C13.9172 3.55647 15.7327 3.73585 17.3578 4.45992C17.7361 4.6285 17.9062 5.07189 17.7376 5.45024C17.569 5.8286 17.1256 5.99865 16.7473 5.83006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0301 5.4694C22.3231 5.76215 22.3233 6.23703 22.0306 6.53006L14.5306 14.0376C14.39 14.1783 14.1992 14.2574 14.0002 14.2575C13.8012 14.2575 13.6104 14.1785 13.4697 14.0378L11.2197 11.7878C10.9268 11.4949 10.9268 11.0201 11.2197 10.7272C11.5126 10.4343 11.9874 10.4343 12.2803 10.7272L13.9997 12.4466L20.9694 5.46993C21.2622 5.1769 21.737 5.17666 22.0301 5.4694Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_3003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 3)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/complete.a0e04e62a01e2dec5d5771782459989f.svg";